export const SALE_ROLE = 'sale';
export const ADMIN_ROLE = 'admin';
export const HO_ROLE = 'ho';
export const CN_ROLE = 'cn';
export const QLD_ROLE = 'qld';
export const QTCN_ROLE = 'qtcn';
export const ACCOUNTANT_ROLE = 'kt';
export const STOREKEEPER_ROLE = 'tk';
export const TREASURER_ROLE = 'tq';
export const NS_ROLE = 'ns';
export const PC_ROLE = 'pc';
export const KTD_ROLE = 'ktd';
